module.exports = __webpack_public_path__ + "static/media/slider-home-start-ups-slide-01-image-01.9f2aa898.png";